// 设备管理韩文文案
const ko = {
  categoryManagement: "장비 카테고리 관리",
  addOrEditEquipmentCategory: "장비 카테고리 추가/편집",
  addOrEditEquipmentInfo: "장비 정보 추가/편집",
  addRootCategory: "메인 카테고리 추가",
  addSubCategory: "하위 카테고리 추가",
  batchSubCategories: "하위 카테고리",
  addBatchSubCategory: "하위 카테고리 추가",
  removeSubCategory: "하위 카테고리 제거",
  subCategoryItem: "하위 카테고리 {{index}}",
  editCategory: "카테고리 편집",
  disableCategory: "카테고리 비활성화",
  enableCategory: "카테고리 활성화",
  categoryCode: "카테고리 코드",
  categoryName: "카테고리 이름",
  categoryDesc: "카테고리 설명",
  sortOrder: "정렬 순서",
  level: "레벨",
  enabled: "활성화됨",
  disabled: "비활성화됨",
  selectCategoryPlaceholder: "장비 카테고리를 선택하세요",
  noCategoryData: "장비 카테고리가 없습니다",
  categoryCodeRequired: "카테고리 코드를 입력하세요",
  categoryNameRequired: "카테고리 이름을 입력하세요",
  confirmDisableCategory: "비활성화하면 모든 하위 카테고리도 비활성화됩니다. 계속하시겠습니까?",
  confirmEnableCategory: "활성화하면 모든 상위 카테고리도 활성화됩니다. 계속하시겠습니까?",
  categoryFetchFailed: "장비 카테고리 작업에 실패했습니다",
  categoryOperationSucceeded: "장비 카테고리 작업이 완료되었습니다",
  equipmentLedger: "장비 목록",
  myBorrowed: "내 대여 장비",
  maintainUpcoming: "정비 도래",
  maintainUpcomingQuery: "정비 도래 조회",
  equipmentList: "장비 목록",
  addEquipment: "장비 추가",
  editEquipment: "장비 편집",
  equipmentDetail: "장비 상세",
  equipmentCategory: "장비 카테고리",
  equipmentNumber: "장비 번호",
  equipmentName: "장비 이름",
  equipmentKeywordPlaceholder: "장비 키워드를 입력하세요",
  equipmentStatus: "장비 상태",
  brand: "브랜드",
  model: "모델",
  serialNo: "일련번호",
  qrCode: "QR 코드",
  disableEquipment: "비활성화",
  enableEquipment: "활성화",
  maintenanceRecord: "정비 기록",
  borrowEquipment: "대여",
  returnEquipment: "반납",
  recordFlow: "기록 내역",
  recordDetail: "기록 상세",
  operator: "작업자",
  borrower: "대여자",
  returnAt: "실제 반납 시간",
  confirmDisableEquipment: "이 장비를 비활성화하시겠습니까?",
  confirmEnableEquipment: "이 장비를 활성화하시겠습니까?",
  equipmentStateUpdated: "장비 상태가 변경되었습니다",
  equipmentStateUpdateFailed: "장비 상태 변경에 실패했습니다",
  qrCodeFetchFailed: "QR 코드를 불러오지 못했습니다",
  noQrCodeData: "QR 코드 데이터가 없습니다",
  addMaintenanceRecord: "정비 기록 추가",
  recordType: "기록 유형",
  recordTypeRequired: "기록 유형을 선택하세요",
  occurredAt: "발생 시간",
  occurredAtRequired: "발생 시간을 선택하세요",
  expectedReturnAt: "예상 반납 시간",
  scrapEquipment: "폐기",
  confirmScrapEquipment: "장비를 폐기하면 복구할 수 없습니다. 계속하시겠습니까?",
  recordCost: "비용",
  recordCostCurrency: "통화",
  odometer: "사용량",
  vendor: "서비스 업체",
  recordComment: "비고",
  recordTypesFetchFailed: "기록 유형을 불러오지 못했습니다",
  recordListFetchFailed: "기록 내역을 불러오지 못했습니다",
  recordFetchFailed: "기록 상세를 불러오지 못했습니다",
  noRecordDetail: "기록 상세 정보가 없습니다",
  addRecordSucceeded: "정비 기록이 추가되었습니다",
  addRecordFailed: "정비 기록 추가에 실패했습니다",
  keeperOrg: "보관 부서",
  ownedOrg: "구매/소유 부서",
  currentUser: "현재 사용자",
  location: "위치",
  placeLocation: "배치 장소",
  editPlaceLocation: "배치 장소 수정",
  placeLocationUpdateSucceeded: "배치 장소가 업데이트되었습니다",
  placeLocationUpdateFailed: "배치 장소 업데이트에 실패했습니다",
  maintainDays: "정비 주기(일)",
  maintainThreshold: "정비 주기(사용량)",
  dueByDays: "일수 기준",
  dueByThreshold: "사용량 기준",
  due: "도래",
  notDue: "미도래",
  remainDays: "남은 일수",
  remainThreshold: "남은 사용량",
  lastMaintainAt: "최근 정비 시간",
  lastMaintainOdometer: "이전 사용량",
  currentOdometer: "현재 사용량",
  purchaseInfo: "구매 정보",
  purchaseAt: "구매일",
  purchasePrice: "구매 가격",
  purchaseCurrency: "구매 통화",
  supplier: "공급업체",
  createdBy: "생성자",
  createdAt: "생성 시간",
  updatedBy: "수정자",
  updatedAt: "수정 시간",
  actions: "작업",
  equipmentNameRequired: "장비 이름을 입력하세요",
  keeperOrgRequired: "보관 부서를 선택하세요",
  rootCategoryCannotAdd: "최상위 카테고리에는 장비를 추가할 수 없습니다. 하위 카테고리를 선택하세요",
  addEquipmentSucceeded: "장비가 추가되었습니다",
  editEquipmentSucceeded: "장비가 수정되었습니다",
  equipmentSaveFailed: "장비 저장에 실패했습니다",
  equipmentFetchFailed: "장비 상세 정보를 불러오지 못했습니다",
  equipmentListFetchFailed: "장비 목록을 불러오지 못했습니다",
  myBorrowedFetchFailed: "대여 장비를 불러오지 못했습니다",
  upcomingMaintainFetchFailed: "정비 도래 장비를 불러오지 못했습니다",
  equipmentStatusFetchFailed: "장비 상태를 불러오지 못했습니다",
  noEquipmentDetail: "장비 상세 정보가 없습니다",
};

export default ko;
